import type { CityConfig } from "@/pages/city-template/types";

export const columbiaTnConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Columbia",
  state: "Tennessee",
  stateAbbr: "TN",
  slug: "columbia-tn",
  route: "/columbia-tn",
  title: "Emergency & Expedited Passport Services Columbia TN | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Columbia, TN — as fast as 24 hours. No Columbia passport agency. Fast Passport Center couriers to the Atlanta Passport Agency at 805 Broadway, about 50 miles north. A+ BBB rated. Serving Columbia State Community College students, Maury County families, and all South Middle Tennessee travelers heading abroad for study, business, or vacation.",
  h1: "Emergency & Expedited Passport Services in Columbia, TN",
  heroSubtitle: "Columbia is the seat of Maury County in South Middle Tennessee, just 50 miles south of Nashville along I-65. Known as Muletown for its historic mule-trading heritage, Columbia sits between the Highland Rim and the Tennessee Valley. Fast Passport Center's registered couriers deliver your documents to the Atlanta Passport Agency at 805 Broadway so you get a new or renewed passport as fast as 24 hours — whether you're a Columbia State Community College student preparing for study abroad, a Maury County professional heading to an international conference, or a South Middle Tennessee family planning an overseas adventure.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Columbia%20Tennessee%20historic%20downtown%20square%20with%20Maury%20County%20Courthouse%20architecture%20and%20charming%20small%20southern%20town%20Main%20Street%20during%20golden%20afternoon%20sunlight%2C%20Muletown%20heritage%20with%20tree%20lined%20streets%20and%20warm%20atmosphere%2C%20wide%20angle%20professional%20photography%20with%20clean%20composition%20and%20natural%20colors&width=1800&height=700&seq=columbia-tn-hero-001&orientation=landscape",
  heroImageAlt: "Columbia Tennessee historic downtown with Maury County Courthouse and southern charm",
  geoPosition: "35.6151;-87.0358",
  geoPlacename: "Columbia, Tennessee",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Approximately 230 miles southeast of Columbia — about 3.5 hours via I-65/I-24",
  },
  nearbyCitiesZips: [
    { name: "Columbia", zips: "38401, 38402" },
    { name: "Spring Hill", zips: "37174" },
    { name: "Mount Pleasant", zips: "38474" },
    { name: "Lewisburg", zips: "37091" },
    { name: "Lawrenceburg", zips: "38464" },
    { name: "Pulaski", zips: "38478" },
    { name: "Hohenwald", zips: "38462" },
    { name: "Lynnville", zips: "38472" },
    { name: "Santa Fe", zips: "38482" },
    { name: "Hampshire", zips: "38461" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Atlanta Passport Agency — about 50 miles from Columbia via I-65 North" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "South Middle Tennessee Hub", desc: "Serving Columbia, Spring Hill, Mount Pleasant, Lewisburg, and all Maury County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Columbia case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Nashville TN", route: "/nashville" },
    { name: "Expedited passport in Franklin TN", route: "/franklin-tn" },
    { name: "Urgent passport in Columbia TN", route: "/columbia-tn" },
    { name: "Tennessee passport hub", route: "/tennessee" },
    { name: "Fast passport in Murfreesboro TN", route: "/murfreesboro" },
    { name: "Expedited passport in Cookeville TN", route: "/cookeville" },
    { name: "Emergency passport in Chattanooga TN", route: "/chattanooga" },
  ],
  fpcOfficeAddress: "805 Broadway, Nashville, TN 37203",
  fpcOfficeNote: "Fast Passport Center serves Columbia remotely via secure courier. Our registered couriers hand-deliver your documents to the Atlanta Passport Agency at 805 Broadway — approximately 50 miles north. Columbia sits directly on the I-65 corridor, making overnight courier routing to Nashville exceptionally efficient. Our dedicated agents ensure Maury County travelers never need to make the drive up I-65 for passport processing.",
  fpcOfficeDistance: "Serving all of Maury County and South Middle Tennessee",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Columbia, Spring Hill, Mount Pleasant, Lewisburg, and the Maury County corridor. From Columbia State Community College students studying abroad to South Middle Tennessee professionals heading to international assignments, we help Muletown travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Columbia and nearby communities including Spring Hill, Mount Pleasant, Lewisburg, Lawrenceburg, Pulaski, and the entire Maury County area.",
  howItWorksIntro: "Most Columbia travelers complete everything online and ship documents overnight. At approximately 50 miles from Nashville, Fast Passport Center provides fast courier turnaround for Maury County residents — just a short drive up I-65 but we save you the trip entirely.",
  mistakesIntro: "Columbia travelers, including Columbia State students studying abroad and South Middle Tennessee professionals heading to international conferences, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Columbia and Maury County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Columbia? Here are the most common ones we hear from Maury County and South Middle Tennessee travelers.",
  statePageRoute: "/states/tennessee",
  statePageName: "Tennessee",
  dmvWebsite: "https://www.tn.gov/safety/driver-services.html",
  dmvLabel: "Tennessee Department of Safety — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for Columbia State students going abroad",
        "Perfect for Maury County professional travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from BNA",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 805 Broadway",
        "Life-or-death emergencies only",
        "50 miles to Nashville (50 minutes via I-65 North)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Columbia is just 50 miles from the Atlanta Passport Agency — our courier service saves Maury County travelers the I-65 drive.",
      bullets: ["Maury County coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Maury County",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Columbia adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Columbia and Maury County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Columbia and Maury County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Columbia and Maury County residents with DS-64 form guidance and courier routing to Nashville.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Nashville agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Maury County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Columbia and Maury County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Columbia TN", description: "Urgent passport processing for Columbia, TN travelers via Atlanta Passport Agency courier — 50 miles from Columbia." },
    { name: "Passport Renewal Columbia TN", description: "Fast passport renewal for Columbia and Maury County, Tennessee residents." },
    { name: "New Passport Columbia TN", description: "First-time passport application assistance for Columbia and Maury County area residents." },
    { name: "Lost Passport Columbia TN", description: "Passport replacement for lost or stolen passports for Columbia and Maury County residents." },
    { name: "Child Passport Columbia TN", description: "Minor passport services for Columbia and Maury County families." },
    { name: "Name Change Passport Columbia TN", description: "Passport name change service for Columbia, TN residents." },
  ],
  testimonials: [
    {
      name: "Megan D.",
      location: "Columbia State Student",
      rating: 5,
      text: "I'm a Columbia State nursing student who got accepted to a medical mission trip in Honduras. Realized 2 weeks before departure my passport had expired. Fast Passport Center renewed it in 4 business days. My dedicated agent walked me through every step — I didn't have to miss a single clinical shift.",
      service: "Emergency Renewal",
    },
    {
      name: "Robert H.",
      location: "Spring Hill, TN",
      rating: 5,
      text: "GM supplier quality engineer heading to a last-minute audit in Stuttgart. My passport was expired and I had 8 days before my flight. Fast Passport Center had me a new one in 3 business days. The courier service to Nashville was seamless — didn't even have to leave my office.",
      service: "Passport Renewal",
    },
    {
      name: "The C Family",
      location: "Columbia, TN",
      rating: 5,
      text: "Maury County family of five planning a summer trip to Ireland. We needed three adult renewals and two child passports with only 6 weeks before departure. Fast Passport Center handled all five applications simultaneously — every passport arrived in 9 business days.",
      service: "Family Applications",
    },
    {
      name: "Patricia W.",
      location: "Mount Pleasant, TN",
      rating: 5,
      text: "Retired teacher who realized my passport was missing 12 days before a long-planned Danube River cruise. Fast Passport Center helped with the DS-64 lost passport form and couriered my replacement through Nashville. Had my passport in 5 business days — didn't miss the cruise.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "col-1",
      name: "Columbia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "417 W 7th St",
      city: "Columbia",
      state: "TN",
      zip: "38401",
      phone: "(931) 388-4532",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Columbia — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Columbia and Maury County residents. Appointment required. Located near the downtown square.",
      icon: "ri-mail-line",
    },
    {
      id: "col-2",
      name: "Maury County Clerk Office",
      type: "County Clerk Passport Acceptance",
      address: "1 Public Sq",
      city: "Columbia",
      state: "TN",
      zip: "38401",
      phone: "(931) 375-1000",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Columbia — Downtown Square",
      website: "https://www.maurycounty-tn.gov",
      websiteLabel: "Maury County Government",
      notes: "County clerk passport acceptance services in the historic Maury County Courthouse on the downtown square. Convenient central location.",
      icon: "ri-government-line",
    },
    {
      id: "col-3",
      name: "Spring Hill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2235 Wall St",
      city: "Spring Hill",
      state: "TN",
      zip: "37174",
      phone: "(931) 486-2686",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Spring Hill — 10 miles north of Columbia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient option for northern Maury County residents and Spring Hill residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "col-4",
      name: "Lewisburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "330 N 1st Ave",
      city: "Lewisburg",
      state: "TN",
      zip: "37091",
      phone: "(931) 359-2551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lewisburg — 20 miles southeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Marshall County residents. Convenient for southeastern Maury County and Lewisburg-area travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "col-5",
      name: "Franklin Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "810 Oak Meadow Dr",
      city: "Franklin",
      state: "TN",
      zip: "37064",
      phone: "(615) 791-1117",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Franklin — 30 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment availability than Columbia locations. Convenient for northern Maury County residents near Spring Hill.",
      icon: "ri-mail-line",
    },
    {
      id: "col-6",
      name: "Lawrenceburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "221 N Military Ave",
      city: "Lawrenceburg",
      state: "TN",
      zip: "38464",
      phone: "(931) 762-3229",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lawrenceburg — 30 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lawrence County residents. Alternative for southwestern Maury County travelers.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Agency", agency: "230 miles — 3.5 hour drive to Atlanta via I-65/I-24, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Best Price Guarantee", agency: "No — government fees only", fpc: "Yes — 30-100% less than resellers" },
    { feature: "Local Expertise", agency: "Generic — no local knowledge", fpc: "Yes — South Middle TN travel patterns and guidance" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Assuming You Can Just Drive Up to Nashville for Same-Day Service",
      description: "Columbia is only 50 miles from Nashville — an easy 50-minute drive on I-65. But the Atlanta Passport Agency at 805 Broadway requires pre-scheduled NPIC appointments and does not accept walk-ins. Appointments often fill 2–3 weeks in advance. You cannot simply 'run up to Nashville' for same-day processing.",
    },
    {
      icon: "ri-calendar-line",
      title: "Columbia State Students Waiting Until Semester Break",
      description: "Columbia State Community College students accepted to study abroad programs often wait until semester break to handle passport applications — right when the Columbia Post Office and Maury County Clerk are busiest. Summer study abroad planning should start passport applications in March, not late April or May.",
    },
    {
      icon: "ri-global-line",
      title: "Confusing Mule Day Travel With International Travel Readiness",
      description: "Columbia famously hosts Mule Day each spring, drawing visitors from across the country. Some Maury County residents assume that because they travel domestically for events, international passport rules are similarly flexible. International travel requires passports valid 6 months beyond your return date — domestic travel does not prepare you for this requirement.",
    },
    {
      icon: "ri-restart-line",
      title: "Not Checking Passport Validity Before Booking International Flights From BNA",
      description: "Columbia travelers typically fly from Nashville International Airport (BNA), just 50 minutes north. Many book international flights months ahead without checking passport expiration dates. Most countries require 6 months passport validity beyond your return date. If your passport expires within 6 months of travel, airlines may deny boarding.",
    },
    {
      icon: "ri-image-line",
      title: "Using Drugstore Photos That Do Not Meet State Department Standards",
      description: "Columbia residents sometimes use drugstore photo services that produce photos with shadows, incorrect sizing, or non-white backgrounds. Passport photos must be exactly 2x2 inches with a pure white background, neutral expression, and no glasses — only verified passport photo services meet U.S. Department of State standards.",
    },
    {
      icon: "ri-file-list-line",
      title: "Renewing by Mail When In-Person Is Required",
      description: "Columbia residents with passports that expired more than 5 years ago, were issued under age 16, or have a name change without documentation must use Form DS-11 (in-person application) — not DS-82 (mail-in). Filing the wrong form means your application gets rejected and you start over.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Columbia, Spring Hill, or Franklin." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Atlanta Passport Agency — 50 miles north via I-65." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Atlanta Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Columbia or Maury County address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Columbia from the Nashville passport agency?",
      a: "Columbia is approximately 50 miles from the Atlanta Passport Agency at 805 Broadway — about a 50 minute drive north via I-65. However, the Nashville agency requires pre-scheduled NPIC appointments and does not accept walk-ins. Appointments often fill 2–3 weeks in advance.",
    },
    {
      q: "Does Columbia, TN have its own passport agency?",
      a: "No. Columbia does not have a passport agency. The closest passport agency is the Atlanta Passport Agency at 805 Broadway, about 50 miles north. Columbia only has passport acceptance facilities — the Columbia Post Office at 417 W 7th St and the Maury County Clerk's office — which can accept DS-11 applications but cannot process or expedite them.",
    },
    {
      q: "I'm a Columbia State Community College student — how fast can I get a passport for study abroad?",
      a: "Columbia State students heading to study abroad programs are frequent clients. Emergency processing delivers passports in 24–48 hours. Standard expedited processing runs 2–9 business days. We recommend starting the process at least 2–3 months before your program start date to allow time for student visa processing.",
    },
    {
      q: "Where do Columbia travelers typically fly internationally?",
      a: "Columbia travelers typically fly from Nashville International Airport (BNA), just 50 minutes north via I-65. BNA offers direct international flights and extensive domestic connections to major hubs. For the fastest international connections, many Columbia travelers also drive 2.5 hours to Atlanta (ATL) for direct overseas flights.",
    },
    {
      q: "How fast can I get an emergency passport in Columbia?",
      a: "Emergency processing is typically 24–48 hours for Columbia residents. Given Columbia's location directly on the I-65 corridor and proximity to Nashville's major UPS/FedEx hubs, overnight courier routing is extremely efficient. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "Where can I get passport photos in Columbia?",
      a: "Walgreens at 502 S James Campbell Blvd and CVS Pharmacy at 600 S James Campbell Blvd in Columbia both offer passport photo services. The UPS Store at 2201 Brookmeade Dr also provides passport photos. Always verify your photos meet exact 2x2 inch specifications with a white background.",
    },
    {
      q: "Can the Maury County Clerk's office process my passport?",
      a: "Yes. The Maury County Clerk's office at 1 Public Sq in downtown Columbia accepts passport applications as a passport acceptance facility. They can accept DS-11 applications and verify your documents. Call (931) 375-1000 before visiting to confirm current passport service hours.",
    },
    {
      q: "How do I renew my passport in Columbia?",
      a: "Adult renewals meeting all DS-82 eligibility criteria (16 or older, issued within 15 years, same name) can be done entirely by mail. Fast Passport Center's courier service achieves 2–9 business day turnaround — far faster than self-service USPS (8–11 weeks). If you're not eligible for mail-in renewal, visit the Columbia Post Office or Maury County Clerk for an in-person DS-11 application.",
    },
    {
      q: "Does the Columbia Post Office take walk-in passport appointments?",
      a: "The Columbia Post Office at 417 W 7th St accepts passport applications by appointment Monday through Friday from 9:00 AM to 4:00 PM. Walk-ins are generally not accepted — call (931) 388-4532 to schedule. The post office is often busiest during lunch hours.",
    },
    {
      q: "Can Fast Passport Center help Spring Hill and Lewisburg residents too?",
      a: "Absolutely. We serve all of Maury County including Columbia, Spring Hill, Mount Pleasant, Lewisburg, Hampshire, Santa Fe, and Culleoka. We also serve bordering communities in Marshall, Lawrence, Williamson, and Giles counties. You never need to drive to Nashville for service — our courier handles everything.",
    },
    {
      q: "I work at the GM Spring Hill Manufacturing plant — can you help with an international assignment passport?",
      a: "GM Spring Hill professionals heading to international assignments or training programs should start passport preparation 3–4 months before travel. Fast Passport Center processes passports in 2–9 business days, but allow extra time for any country-specific visa processing after you receive your passport.",
    },
    {
      q: "Is the Maury County Clerk faster than the Columbia Post Office for passport applications?",
      a: "Both the Columbia Post Office and the Maury County Clerk's office serve as passport acceptance facilities with similar processing capabilities. The County Clerk's office at 1 Public Sq often has shorter wait times and more flexible hours (8:00 AM–4:00 PM vs. the post office's 9:00 AM–4:00 PM). However, neither facility can expedite processing — that's where Fast Passport Center's courier service comes in.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Columbia", address: "502 S James Campbell Blvd, Columbia, TN 38401", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Columbia", address: "600 S James Campbell Blvd, Columbia, TN 38401", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/photo" },
    { name: "UPS Store — Columbia", address: "2201 Brookmeade Dr, Columbia, TN 38401", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart Photo — Columbia", address: "2200 Brookmeade Dr, Columbia, TN 38401", hours: "Mon–Sun: 7AM–9PM", website: "https://www.walmart.com/photo" },
    { name: "Walgreens — Spring Hill", address: "4900 Port Royal Rd, Spring Hill, TN 37174", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Cool Springs", address: "1701 Mallory Ln, Brentwood, TN 37027", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    { name: "TN Driver Services — Columbia", address: "1701 Hampshire Pike, Columbia, TN 38401", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Full-service Driver Services Center in Columbia. REAL ID, driver's license, and state ID services for Maury County residents.", featured: true },
    { name: "TN Driver Services — Franklin", address: "3830 Carothers Pkwy, Franklin, TN 37067", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Larger Driver Services Center in Franklin. About 30 miles north of Columbia.", featured: false },
    { name: "TN Driver Services — Lawrenceburg", address: "2415 N Locust Ave, Lawrenceburg, TN 38464", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Alternative Driver Services Center. About 30 miles southwest of Columbia.", featured: false },
  ],
  airports: [
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "50 miles north of Columbia",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Columbia's primary airport — just 50 minutes via I-65 North. Extensive domestic routes with growing international service. The most convenient departure point for Maury County travelers. Co-located with the Atlanta Passport Agency.",
      flightUrl: "https://flynashville.com/",
      flightLabel: "BNA Airport",
      featured: true,
    },
    {
      code: "HSV",
      name: "Huntsville International Airport",
      distance: "80 miles southeast of Columbia",
      address: "1000 Glenn Hearn Blvd SW, Huntsville, AL 35824",
      note: "Alabama's largest commercial airport with domestic routes. About 1 hour 20 minutes via I-65 South and I-565. Alternative for southern Maury County residents.",
      flightUrl: "https://www.flyhuntsville.com/",
      flightLabel: "HSV Airport",
      featured: false,
    },
    {
      code: "ATL",
      name: "Hartsfield-Jackson Atlanta International",
      distance: "230 miles southeast of Columbia",
      address: "6000 N Terminal Pkwy, Atlanta, GA 30320",
      note: "World's busiest airport with direct international flights worldwide. About 3 hours 30 minutes via I-65 and I-24. Major international gateway for South Middle Tennessee travelers.",
      flightUrl: "https://www.atl.com/",
      flightLabel: "ATL Airport",
      featured: false,
    },
    {
      code: "CHA",
      name: "Chattanooga Metropolitan Airport",
      distance: "130 miles east of Columbia",
      address: "1001 Airport Rd, Chattanooga, TN 37421",
      note: "Regional airport with domestic routes. About 2 hours 15 minutes via I-24. Alternative for southeastern Maury County residents.",
      flightUrl: "https://www.chattairport.com/",
      flightLabel: "CHA Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificates", desc: "Request certified birth certificates from the Tennessee Department of Health Vital Records. Online, mail, or in-person options for Maury County.", url: "https://www.tn.gov/health/health-program-areas/vital-records/birth-certificates.html" },
    { icon: "ri-file-list-2-line", label: "Death Certificates", desc: "Obtain certified death certificates through Tennessee Vital Records. Required for estate and legal matters in Maury County.", url: "https://www.tn.gov/health/health-program-areas/vital-records/death-records.html" },
    { icon: "ri-hearts-line", label: "Marriage Certificates", desc: "Request marriage license records from the Maury County Clerk. Certified copies available for name change passport applications.", url: "https://www.tn.gov/health/health-program-areas/vital-records/marriage.html" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Maury County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.tn.gov/health/health-program-areas/vital-records/divorce.html" },
  ],
};